export const IsSoldFilter = 'isSold';
export const IsNotSoldFilter = 'isNotSold';
export const isActiveFilter = 'active';
export const inactiveFilter = 'inactive';
export const startsWithFilter = 'startsWith'

export const FILTER_FUNCTIONS = {
  [IsSoldFilter]: deviceObj => !!deviceObj.isSold,
  [IsNotSoldFilter]: deviceObj => !deviceObj.isSold,
  [isActiveFilter]: obj => !!obj.isActive,
  [inactiveFilter]: obj => !obj.isActive,
  [startsWithFilter]: (obj, filterKey) => {
    const items = filterKey.split("|||")
    const key = items[1]
    const value = items[2]
    if (typeof obj[key] === "string") {
      return obj[key].startsWith(value)
    }
    return false
  }
};

export const FILTER_LABELS = {
  [IsSoldFilter]: 'Sold Devices',
  [IsNotSoldFilter]: 'UnSold Devices',
  [isActiveFilter]: 'Active Users',
  [inactiveFilter]: 'Inactive Users',
  default: 'All Devices',
  owned: 'All Owned Devices',
};
